import {
  CreateAssetTag,
  IqueryParams,
  AssetTagResponse,
  UpdateAssetTag,
} from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

const createAssetTag = async (data: CreateAssetTag) => {
  return apiService.apiRequest<AssetTagResponse>("post", `asset-tags`, data);
};

const updateAssetTag = async (asset_tag_id: string, data: UpdateAssetTag) => {
  return apiService.apiRequest<AssetTagResponse>(
    "put",
    `asset-tags/${asset_tag_id}`,
    data
  );
};

const getAssetTags = async (queryParams?: IqueryParams) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<AssetTagResponse[]>("get", `asset-tags${query}`);
};

const getAssetTag = async (asset_tag_id: string) => {
  return apiService.apiRequest<AssetTagResponse>(
    "get",
    `asset-tags/${asset_tag_id}`
  );
};

export const AssetTagApi = {
  getAssetTags,
  getAssetTag,
  createAssetTag,
  updateAssetTag,
};
